import { connect, ConnectedProps } from "react-redux";
import { useParams } from "react-router-dom";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { IStore } from "../../../store/IStore";
import { ConfigValueDto } from "../../../store/models/config/ConfigDto";
import { ConfigGroupKey } from "../../../store/models/config/ConfigGroupKey";
import MenuLayout from "../../app/MenuLayout";
import ConfigValueForm from "./ConfigValueForm";
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";

export interface ConfigValueFormDto extends ConfigValueDto {
  isNew?: boolean;
}

export interface ConfigValueProps {
  configGroupKey: ConfigGroupKey;
  entityName: string;
  valueName: string;
}

export const receiptDetailProps: ConfigValueProps = {
  configGroupKey: ConfigGroupKey.RECEIPT_DETAIL,
  entityName: i18n.t("setup.filter"),
  valueName: i18n.t("setup.jsonPath"),
};

export const customFieldProps: ConfigValueProps = {
  configGroupKey: ConfigGroupKey.CUSTOM_FIELD,
  entityName: i18n.t("setup.additionalFields"),
  valueName: i18n.t("setup.designation"),
};

const defaultConfigValue = { isNew: true } as ConfigValueFormDto;

const ConfigValueFormPage = (props: ThunkProps & ConfigValueProps) => {
  const { configGroups } = props;
  const { id } = useParams<"id">();
  const { t } = useTranslation();

  let matchingConfigGroups = configGroups.find((configGroup) => configGroup.key === props.configGroupKey);

  let configValue;
  if (matchingConfigGroups?.values) {
    configValue = matchingConfigGroups?.values.find((value) => value.key === id);
  }

  return (
    <MenuLayout headline={props.entityName + " " + (id ? t("setup.edit") : t("setup.create"))}>
      <ConfigValueForm configValue={configValue || defaultConfigValue} {...props} />
    </MenuLayout>
  );
};

const mapStateToProps = (state: IStore) => ({
  configGroups: state.configGroups.configGroups,
});
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators({}, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);
type ThunkProps = ConnectedProps<typeof connector>;
export default connector(ConfigValueFormPage);
